import { render } from "./PlanView.vue?vue&type=template&id=08778f6a&scoped=true"
import script from "./PlanView.vue?vue&type=script&lang=js"
export * from "./PlanView.vue?vue&type=script&lang=js"

import "./PlanView.vue?vue&type=style&index=0&id=08778f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08778f6a"]])

export default __exports__